module.exports = __webpack_public_path__ + "img/campaignmonitor_logo@3x.937cb1d2.png";